<div class="grid">
  @if (initialized && contractsRuntime && userProfileDto) {

    <div class="flex flex-column flex-auto col-12">
      <div class="surface-card border-round-lg lg:p-4 p-1">
        <div class="flex align-items-start flex-column lg:flex-row lg:justify-content-between">
          <div class="flex align-items-center md:align-items-start flex-column w-full">
            <div
              class="flex justify-content-between flex-wrap align-items-center w-full mb-2 md:mt-0 mt-2 md:ml-0 ml-2">
              <div class="flex align-items-center gap-2">
                <div
                  class="lg:w-5rem lg:h-5rem w-4rem h-4rem flex justify-content-center align-content-center border-circle">
                  <img [src]="userProfilePhoto ?? 'assets/images/blank_user.png'"
                       class="w-3rem h-3rem m-auto border-circle" style="object-fit: contain"/>
                </div>
                <div class="flex flex-column gap-1">
                <span
                  class="text-900 font-medium md:text-3xl text-xl">{{ userProfileDto.firstName }} {{ userProfileDto.lastName }}</span>
                  <span class="text-color-secondary font-light md:text-lg mb-2">{{ userProfileDto.email }}</span>
                </div>
              </div>

              <div class="md:block hidden" [ngClass]="showContractFrequency ? '' : 'block'">
                <p-selectButton
                  class="ml-2" (onChange)="handleFrequencyChangeFilter(contractFrequency)"
                  [options]="contractFrequencyOptions"
                  [(ngModel)]="contractFrequency" [allowEmpty]="false" optionLabel="label" optionValue="value">
                </p-selectButton>
              </div>
            </div>
            <div class="flex flex-column align-items-center md:align-items-start w-full md:mx-1">
              <!--              (onFrequencyChange)="handleFrequencyChangeFilter($event)"-->
              <app-contract-groups class="w-full" (showGroupChange)="handleShowGroup($event)"
                                   [contractsRuntime]="contractsRuntime" [contractFrequency]="contractFrequency" [busy]="busy">
              </app-contract-groups>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-6">
      <app-insurable-objects [insurableObjects]="contractsRuntime.insurableObjects"></app-insurable-objects>
    </div>

    <div class="col-12 lg:col-6">
      <app-notifications></app-notifications>
    </div>
    <div class="col-12">
      <user-insurances></user-insurances>
    </div>

    @if (showUnManagedContracts?.length) {
      <div class="col-12">
        <app-contracts [contractsRuntime]="contractsRuntime"
                       [showUnmanaged]="true"
                       [showTooltip]="true"
                       [header]="'Nicht betreute Verträge'"
                       [tooltipText]="'Diese Versicherungsunternehmen arbeiten nicht mit Maklern zusammen. Melde dich bei uns, damit wir hier Klarheit für dich schaffen!'"
                       source="ds/home">
        </app-contracts>
      </div>
    }

    <div class="col-12">
      <!--      Ticket: DEF1000000956-->
      <app-contracts
        [contractsRuntime]="contractsRuntime"
        [showActiveOnly]="true"
        [showUnmanaged]="false"
        source="ds/home"></app-contracts>
    </div>


    <div class="col-12">
      <app-promotions></app-promotions>
    </div>
  }
</div>
